export const LOCAL_STORAGE_ACCESS_TOKEN = 'accessToken'
export const LOCAL_STORAGE_REFRESH_TOKEN = 'refreshToken'
export const LOCAL_STORAGE_SELECTED_RESELLER_ID = 'selectedResellerId'
export const LOCAL_STORAGE_USER_INVITATION_TOKEN = 'userInvitationToken'
